// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "csr-" + {"179":"urql-service","407":"cart-service","815":"user-session-service"}[chunkId] + "-" + {"179":"abce8bb5720373f60e9b","407":"54479f4d626c28b7937f","815":"8c85ef506e4654a4f432"}[chunkId] + ".js";
};